import { useEffect } from "react";

const BRAND = "Wingwomen";
const DEFAULT_TITLE = "Wingwomen | Peer Support for Women's Reproductive Health";
const DEFAULT_DESC =
  "Wingwomen connects women with peers who have lived the same reproductive-health journey — endometriosis, PMOS, IVF, pregnancy loss, postpartum, menopause. AI-matched, anonymous by default, HIPAA-aligned.";

/**
 * Set document.title and meta description for the current page.
 * Usage: usePageMeta({ title: "Home", description: "..." });
 * Title renders as "<Brand> | <title>". If title is falsy, uses the default homepage title.
 */
export default function usePageMeta({ title, description } = {}) {
  useEffect(() => {
    document.title = title ? `${BRAND} | ${title}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", desc);
    // Basic OpenGraph + Twitter
    const ogTitle = title ? `${BRAND} | ${title}` : DEFAULT_TITLE;
    [
      ["og:title", ogTitle],
      ["og:description", desc],
      ["twitter:title", ogTitle],
      ["twitter:description", desc],
    ].forEach(([prop, val]) => {
      const attr = prop.startsWith("og:") ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, prop);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    });
  }, [title, description]);
}
